import Swal from 'sweetalert2'

import { otnSingleHtml } from './otnSingleHtml'
import {
  makeAjaxCall,
  handleDataOfDelay,
  handleOldDataOfDelay,
  sweetAlertCommonParams,
  selectedOptionsTextArray,
} from '../../utils/functions'
import { lang } from '../../assets/lang'

const base_url = window.xitFlowBuilderData.base_url
const page_table_id = window.xitFlowBuilderData.page_table_id
const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
const isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon

export const otnSingleModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.otn_single_modal_title,
    html: otnSingleHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })
      
      const templateNameElement = $('#template-name')
      const labelIdsElement = $("#label-ids")
      const sequenceElement = $("#sequence")
      
      if (isSequenceAddonAvailable) {
        sequenceElement.parent().removeClass('d-done').addClass('d-block')

        sequenceElement.on('change', function() {
          Swal.resetValidationMessage()
          const currentValue = $(this).val()
          if ('newSequence' === oldData.sequence && 'newSequence' !== currentValue) {
            node.otnSingleNodeNewSequenceValueChangeStatus = true
            Swal.showValidationMessage(lang.otn_single_html_sequence_info)
          }
        })
      }

      templateNameElement.val(oldData.templateName || '')
      $('#action-button-messenger-engagement-languages').val(oldData.language || 'en_US').trigger('change')

      const labelSequenceData = {
        url: base_url+'visual_flow_builder/get_label_sequence_dropdown',
        data: { 
          page_table_id, 
          requested_from: 'action_button', 
          instagram_bot_addon 
        },
      }

      makeAjaxCall(function(response) {
        labelIdsElement.html(response.label_dropdown)
        sequenceElement.html(response.drip_dropdown)

        labelIdsElement.val(oldData.labelIds || '').trigger('change')
        sequenceElement.val(oldData.sequence || '').trigger('change')
      }, labelSequenceData)

      // Handles old data of delay system
      handleOldDataOfDelay(oldData)
    },

    preConfirm: () => {
      const templateName = $('#template-name').val()

      const labelIds = $('#label-ids').val()
      const labelIdTexts = $('#label-ids option:selected')
      const labelIdTextsArray = selectedOptionsTextArray(labelIdTexts) 

      const sequence = $("#sequence").val()
      const sequenceText = $('#sequence option:selected').text()

      if (! templateName) {
        Swal.showValidationMessage(lang.otn_single_modal_template_name_msg)
      }

      // Handles data of delay system
      const delayData = handleDataOfDelay()

      return {
        templateName,
        labelIds,
        labelIdTextsArray,
        sequence,
        sequenceText,
        ...delayData,
      }
    },
  })
}